// themeMode — this console's light/dark mode store. Thin wrapper around
// corenet's shared `createThemeModeStore` (promoted out of agate's
// app/themeMode.ts) so main.tsx and Layout.tsx share one instance instead
// of each creating their own independent store.
import { createThemeModeStore } from "@bluerock/corenet/tokens";

export const { useThemeMode, setThemeMode, toggleThemeMode } = createThemeModeStore(
  "bluerock:theme-mode",
  "light", // this console has always been light-only until now; keep that as the default
);
